import { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout.js";
import { RequireAdmin, RequireAuth, RequireOwner } from "./components/RequireAuth.js";
import { AllStoresSummary } from "./screens/AllStoresSummary.js";
import { CategoryAdmin } from "./screens/CategoryAdmin.js";
import { ChangePin } from "./screens/ChangePin.js";
import { CsvExport } from "./screens/CsvExport.js";
import { DailySummary } from "./screens/DailySummary.js";
import { PaymentMethodAdmin } from "./screens/PaymentMethodAdmin.js";
import { PinLogin } from "./screens/PinLogin.js";
import { PrintJobHistory } from "./screens/PrintJobHistory.js";
import { PrinterSettings } from "./screens/PrinterSettings.js";
import { ProductAdmin } from "./screens/ProductAdmin.js";
import { Register } from "./screens/Register.js";
import { SalesDetail } from "./screens/SalesDetail.js";
import { SalesHistory } from "./screens/SalesHistory.js";
import { StaffAdmin } from "./screens/StaffAdmin.js";
import { StoreAdmin } from "./screens/StoreAdmin.js";
import { StoreSelect } from "./screens/StoreSelect.js";
import { StoreSettings } from "./screens/StoreSettings.js";
import { SystemDiagnostics } from "./screens/SystemDiagnostics.js";
import { TableAdmin } from "./screens/TableAdmin.js";
import { useAuthStore } from "./stores/authStore.js";

export default function App() {
  const restoreSession = useAuthStore((state) => state.restoreSession);

  useEffect(() => {
    void restoreSession();
  }, [restoreSession]);

  return (
    <Routes>
      <Route path="/login" element={<PinLogin />} />
      <Route path="/change-pin" element={<ChangePin />} />
      <Route
        path="/select-store"
        element={
          <RequireAuth>
            <StoreSelect />
          </RequireAuth>
        }
      />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout>
              <Register />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/sales"
        element={
          <RequireAuth>
            <Layout>
              <SalesHistory />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/sales/:id"
        element={
          <RequireAuth>
            <Layout>
              <SalesDetail />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/daily-summary"
        element={
          <RequireAuth>
            <Layout>
              <DailySummary />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/admin/products"
        element={
          <RequireOwner>
            <Layout>
              <ProductAdmin />
            </Layout>
          </RequireOwner>
        }
      />
      <Route
        path="/admin/categories"
        element={
          <RequireAuth>
            <Layout>
              <CategoryAdmin />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/admin/payment-methods"
        element={
          <RequireAuth>
            <Layout>
              <PaymentMethodAdmin />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/admin/tables"
        element={
          <RequireAuth>
            <Layout>
              <TableAdmin />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/admin/staff"
        element={
          <RequireAdmin>
            <Layout>
              <StaffAdmin />
            </Layout>
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/store-settings"
        element={
          <RequireOwner>
            <Layout>
              <StoreSettings />
            </Layout>
          </RequireOwner>
        }
      />
      <Route
        path="/admin/printer-settings"
        element={
          <RequireAuth>
            <Layout>
              <PrinterSettings />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/admin/print-jobs"
        element={
          <RequireAuth>
            <Layout>
              <PrintJobHistory />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/admin/csv-export"
        element={
          <RequireAuth>
            <Layout>
              <CsvExport />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/admin/diagnostics"
        element={
          <RequireAuth>
            <Layout>
              <SystemDiagnostics />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/admin/all-stores-summary"
        element={
          <RequireAuth>
            <Layout>
              <AllStoresSummary />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/admin/stores"
        element={
          <RequireOwner>
            <Layout>
              <StoreAdmin />
            </Layout>
          </RequireOwner>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
